.orgList {
  margin: 0;
  padding: 0;
  list-style: none;
}

.orgList li + li {
  border-block-start: var(--border-width) solid var(--color-rule);
}

.orgRow {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  color: inherit;
  text-decoration: none;
}

.orgRow:hover {
  background: var(--color-surface-hover);
}

.orgIcon {
  display: grid;
  place-items: center;
  inline-size: 2.5rem;
  block-size: 2.5rem;
  border-radius: var(--radius-md);
  background: var(--color-primary-subtle);
  color: var(--color-primary-subtle-text);
  flex: none;
}

.orgText {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-inline-size: 0;
}

.orgName {
  font-weight: var(--weight-semibold);
  overflow-wrap: anywhere;
}

.orgMeta {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}

.formGrid {
  display: grid;
  gap: var(--space-5);
}
